import { createContext, useContext } from 'react';

import type { TreeMapData } from '../types/treemap.js';

export const TreeMapRawDataContext = createContext<TreeMapData>({
  tree: { nodes: [], name: '', value: 0 },
});

export const useTreeMapRawData = () => useContext(TreeMapRawDataContext);

TreeMapRawDataContext['displayName'] = 'TreeMapRawDataContext';
